import { authFetch } from "./client";

export const ekedcPaymentKeys = {
  all: ["ekedc-payments"],
  list: (page, size = 10) => ["ekedc-payments", "list", { page, size }],
};

export function formatPaymentDate(date) {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export const fetchEkedcPayments = ({ page = 0, size = 10 } = {}) =>
  authFetch(`disco/ekedc-payments?page=${page}&size=${size}`);

export const createEkedcPayment = (payload) =>
  authFetch("disco/ekedc-payments", {
    method: "POST",
    body: JSON.stringify(payload),
  });

export const updateEkedcPayment = ({ id, ...payload }) =>
  authFetch(`disco/ekedc-payments/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteEkedcPayment = (id) =>
  authFetch(`disco/ekedc-payments/${id}`, {
    method: "DELETE",
  });
